import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
    getbusinessRequest: ['payload', 'route', 'loading'],
    getbusinessSuccess: ['response'],
    getbusinessFailure: null,

    postbusinessRequest: ['payload'],
    postbusinessSuccess: ['response'],
    postbusinessFailure: null,

    getbzcompanyRequest: ['payload'],
    getbzcompanySuccess: ['response'],
    getbzcompanyFailure: null,

    getbusinessblogRequest: ['payload', 'loading'],
    getbusinessblogSuccess: ['response'],
    getbusinessblogFailure: null,

    savebzcompanyRequest: ['payload', 'callback'],
    savebzcompanySuccess: ['response'],
    savebzcompanyFailure: null,

    savebusinessRequest: ['payload'],
    savebusinessSuccess: ['response'],
    savebusinessFailure: null,

    getblogcategoriesRequest: ['loading'],
    getblogcategoriesSuccess: ['response'],
    getblogcategoriesFailure: null,

    gettopiccategoriesRequest: null,
    gettopiccategoriesSuccess: ['response'],
    gettopiccategoriesFailure: null,

    getcompanyusersRequest: ['payload'],
    getcompanyusersSuccess: ['response'],
    getcompanyusersFailure: null,

    postregisterbusinessuserRequest: ['companyId', 'payload'],
    postregisterbusinessuserSuccess: ['response'],
    postregisterbusinessuserFailure: null,

    postaddeditdepartmentsRequest: ['companyId', 'payload', 'callback'],
    postaddeditdepartmentsSuccess: ['response'],
    postaddeditdepartmentsFailure: null,

    postdeletedepartmentRequest: ['businessId', 'companyId', 'departmentId'],
    postdeletedepartmentSuccess: ['response'],
    postdeletedepartmentFailure: null,

    postaddeditteamsRequest: ['companyId', 'payload'],
    postaddeditteamsSuccess: ['response'],
    postaddeditteamsFailure: null,

    postdeleteteamRequest: ['companyId', 'teamId'],
    postdeleteteamSuccess: ['response'],
    postdeleteteamFailure: null,

    postsavejobrolesRequest: ['companyId', 'payload'],
    postsavejobrolesSuccess: ['response'],
    postsavejobrolesFailure: null,

    postsavehcmcompanyRequest: ['payload'],
    postsavehcmcompanySuccess: ['response'],
    postsavehcmcompanyFailure: null,

    getminimalcompanyemployeesRequest: ['companyId', 'cacheBust'],
    getminimalcompanyemployeesSuccess: ['response', 'cacheBust'],
    getminimalcompanyemployeesFailure: null,

    postcompanyfollowRequest: ['payload'],
    postcompanyfollowSuccess: ['response'],
    postcompanyfollowFailure: null,

    postcompanyconnectRequest: ['payload'],
    postcompanyconnectSuccess: ['response'],
    postcompanyconnectFailure: null,

    getcompanyconnectionsRequest: ['payload'],
    getcompanyconnectionsSuccess: ['response'],
    getcompanyconnectionsFailure: null,

    getusersubscriptionsRequest: ['userId', 'loading'],
    getusersubscriptionsSuccess: ['response'],
    getusersubscriptionsFailure: null,

    getsubscriptionreportsRequest: ['loading'],
    getsubscriptionreportsSuccess: ['response'],
    getsubscriptionreportsFailure: null,

    getsubscriptionfrequenciesRequest: ['loading'],
    getsubscriptionfrequenciesSuccess: ['response'],
    getsubscriptionfrequenciesFailure: null,

    postaddsubscriptionRequest: ['payload', 'loading'],
    postaddsubscriptionSuccess: ['response'],
    postaddsubscriptionFailure: null,

    postsavesubscriptionRequest: ['payload', 'loading'],
    postsavesubscriptionSuccess: ['response'],
    postsavesubscriptionFailure: null,

    setbzcompanyRequest: ['company'],

    resetRequest: null,

    // Clear all caches
    clearRequest: null,
});

export const CompanyTypes = Types;
export default Creators;
